import React from "react";

import { EventCardHeader, EventCardHeaderProps } from "../EventCard";

export const FeedEventCardHeader = (props: EventCardHeaderProps) => (
  <EventCardHeader {...props} px={6} />
);
